import { TOTAL_RETAIL } from "./formula-total-retail";
import { TOTAL_COST } from "./formula-total-cost";
import { referenceMetricValueOrCompute } from "../sibling-value-getter/getter";
import { MetricsKind } from "../types";

export const IMU_PERCENTAGE = ({ factoryOptions, getterParams }) => {
    const totalCost = referenceMetricValueOrCompute(
        () => TOTAL_COST({ factoryOptions, getterParams }),
        getterParams,
        MetricsKind.TOTAL_COST
    );
    const totalRetail = referenceMetricValueOrCompute(
        () => TOTAL_RETAIL({ factoryOptions, getterParams }),
        getterParams,
        MetricsKind.TOTAL_RETAIL
    );
    if (totalCost && totalRetail) {
        return ((totalRetail - totalCost) / totalRetail) * 100;
    }

    return undefined;
};
